export default __webpack_public_path__ + "static/media/Rectangle 8.a04d4035.svg";